import React, { Component } from 'react'
import { ButtonSecondary } from '../components/Buttons'
import './RowEditMode.css'

class RowEdit extends Component {
  constructor (props) {
    super(props)
    this.state = {
      delete: false
    }
    this.handleDelete = this.handleDelete.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }
  handleDelete (ev, val) {
    ev.preventDefault()
    this.setState({
      delete: val
    })
  }
  handleClick (ev) {
    ev.preventDefault()
    this.props.history.push('/edit/' + this.props.modalidad + '/' + this.props.id)
  }
  render () {
    if (this.state.delete) {
      return (
        <div className='row_edit row_edit--delete'>
          <div className='row_edit__data'>
            <h4 className='row_edit__title'>{this.props.fecha}</h4>
            <p className='row_edit__meta'>
              {this.props.activa ? <span className='active'>Activa</span> : <span>Cerrada</span>}
              {this.props.actual ? <span className='active'>Actual</span> : null}
            </p>
          </div>
          <div className='row_edit__actions'>
            <span className='row_edit__label' style={{marginRight: '1em'}}>¿Estás seguro?</span>
            <ButtonSecondary
              label='No'
              onClick={(ev) => this.handleDelete(ev, false)}
              sm
            />
            <ButtonSecondary
              label='Si'
              onClick={(ev) => this.props.handleDelete(ev, this.props.id, this.props.cat)}
              sm
              warning
            />
          </div>
        </div>
      )
    }
    return (
      <div className='row_edit'>
        <div className='row_edit__data'>
          <h4 className='row_edit__title'>{this.props.fecha}</h4>
          <p className='row_edit__meta'>
            {this.props.activa ? <span className='active'>Activa</span> : <span>Cerrada</span>}
            {this.props.actual ? <span className='current'>Actual</span> : null}
          </p>
        </div>
        <div className='row_edit__actions'>
          <ButtonSecondary
            label='Editar'
            onClick={this.handleClick}
            sm
          />
          <ButtonSecondary
            label='Borrar'
            onClick={(ev) => this.handleDelete(ev, true)}
            sm
          />
        </div>
      </div>
    )
  }
}

export default RowEdit
